import { FormattedMessage, trans } from '@lingoda/i18n';
import { Alert, Link, Stack, Typography, colorsPalette } from '@lingoda/ui';
import { SupportUrlType, getSupportUrl } from '@lingoda/urls';

export const ClassInClassroomAlert = ({ children }: React.PropsWithChildren<unknown>) => {
    return (
        <Alert variant="outlined" severity="promotion" size="compact" icon={false}>
            <Stack spacing={1} alignItems="flex-start">
                <Typography variant="subtitle1" htmlColor="text.primary">
                    {trans('join-class-in-browser', {}, 'student-common')}
                </Typography>
                <Typography variant="body2" htmlColor="text.primary">
                    <FormattedMessage
                        message={trans('class-in-lingoda-classroom-alert', {}, 'student-common')}
                        values={{
                            a: (chunks) => (
                                <Link
                                    href={getSupportUrl(SupportUrlType.ClassroomStudentFAQ)}
                                    target="_blank"
                                    rel="noreferrer"
                                    sx={{ color: colorsPalette.purpleSolid[100] }}
                                >
                                    {chunks}
                                </Link>
                            ),
                        }}
                    />
                </Typography>
                {children}
            </Stack>
        </Alert>
    );
};
